import "swiper/swiper.min.css";
import "./assets/boxicons-2.0.7/css/boxicons.min.css";
import "./App.scss";
import React, { Suspense } from "react";
import { useEffect, useState } from "react";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { BrowserRouter, Route } from "react-router-dom";
import { useDetectAdBlock } from "adblock-detect-react";
import { HelmetProvider } from "react-helmet-async";
import PropagateLoader from "react-spinners/PropagateLoader";
import Header from "./components/header/Header";
import Routes from "./config/Routes";
import ScrollToTop from "./ScrollToTop";
const Parse = require("parse");
Parse.initialize("SHOWFLIXAPPID", "SHOWFLIXMASTERKEY");
//javascriptKey is required only if you have it on server.

Parse.serverURL = "https://parse.showflix.sbs/parse";
const Footer = React.lazy(() => import("./components/footer/Footer"));
function App() {
  disableReactDevTools();
  const adBlockDetected = useDetectAdBlock();
  const [isLoggedin, setIsLoggedIn] = useState(false);
  useEffect(() => {
    if (adBlockDetected) {
      window.alert("ad block detected");
    }
  }, []);
  useEffect(() => {
    console.clear();
  });

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Route
          render={(props) => (
            <>
              <ScrollToTop />
              <Header {...props} />
              <Routes />
              <Suspense
                fallback={
                  <div>
                    <PropagateLoader></PropagateLoader>
                  </div>
                }
              >
                <Footer />
              </Suspense>
            </>
          )}
        />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
